<template>
  <div class="baseBox">
    <div class="contentBox">
      <div class="credentials-align">
          <span class="item-title"><i>*</i>{{$t('credentials_证件类别')}}</span>
          <a-select :value="idCertificate" style="width: 210px" @change="idHandleChange">
            <a-select-option value="营业执照">
              {{$t('credentials_营业执照')}}
            </a-select-option>
            <a-select-option value="税务登记证">
              {{$t('credentials_税务登记证')}}
            </a-select-option>
          </a-select>
          <div><span class="item-title"><i>*</i>{{$t('credentials_证件号码')}}</span><a-input :placeholder="$t('credentials_请填写证件号码')" class="login-input" style="" v-model="idNumber" /></div>
        </div>
        <div class="credentials-align">
          <div><span class="item-title"><i>*</i>{{$t('credentials_企业全称')}}</span><a-input :placeholder="$t('credentials_请与证件名称保持一致')" class="login-input" style="" v-model="businessName" @blur="handleInput"/></div>
          <span class="item-title"><i>*</i>{{$t('credentials_员工规模')}}</span>
          <a-select :value="staff" style="width: 210px" :placeholder="$t('credentials_请选择员工规模')" @change="staffHandleChange">
            <a-select-option value="50人以下">
              {{$t('credentials_50人以下')}}
            </a-select-option>
            <a-select-option value="50-149人">
              {{$t('credentials_50-149人')}}
            </a-select-option>
            <a-select-option value="150-499人">
              {{$t('credentials_150-499人')}}
            </a-select-option>
            <a-select-option value="1000-2999人">
              {{$t('credentials_1000-2999人')}}
            </a-select-option>
            <a-select-option value="3000人以上">
              {{$t('credentials_3000人以上')}}
            </a-select-option>
          </a-select>
        </div>
        <div class="credentials-align">
          <div><span class="item-title"><i>*</i>{{$t('credentials_注册资本')}}</span><a-input :placeholder="$t('credentials_填写注册资本')" @keyup="capital = capital.replace(/[^\d]/g, '')" class="login-input" style="" v-model="capital" /></div>
          <div>
            <span class="item-title"><i>*</i>{{$t('credentials_有效期')}}</span><a-date-picker v-model="lifeSpan" :placeholder="$t('common_conj_date')" @change="dateOnChange" :disabled="isForever" :disabled-date="disabledDate"/>
            <a-checkbox style="margin-left:29px;" :checked="isForever" @change="onChange1">{{$t('credentials_永续')}}</a-checkbox>
          </div>
        </div>
        <div style="display:flex;">
          <span class="item-title"><i>*</i>{{$t('credentials_企业证件附件')}}</span>
          <div class="up-domian">
            <div style="display:flex;">
              <div class="upload-example" v-if="fileList.length === 0"><img src="@/assets/up1.png" alt="" /></div>
              <a-upload
                list-type="picture-card"
                :file-list="fileList"
                accept="image/jpeg,image/jpg,image/png,image/jpg,image/bmp"
                :before-upload="beforeUploads"
                :remove="handremove"
              >
                <div v-if="fileList.length < 4">
                  <a-icon :type="companyLoading ? 'loading' : 'plus'" />
                  <div class="ant-upload-text">
                    {{$t('common_upload')}}
                  </div>
                </div>
              </a-upload>
              <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel">
                <img alt="example" style="width: 100%" :src="previewImage" />
              </a-modal>
            </div>
            <div class="up-tips"><i>*</i>{{$t('credentials_最多可上传四张图片')}}</div>
          </div>
        </div>
        <div class="credentials-align">
          <span class="item-title"><i>*</i>{{$t('credentials_企业证件地址')}}</span>
          <V-distpicker :regiono="companyAdres" @setAddress="companyAddress" />
          <a-input :placeholder="$t('credentials_请填写详细地址')" class="login-input" style="width:274px;height:30px;margin-left:0;" v-model="companyAddressDetail" />
        </div>
        <div class="credentials-align"><span class="item-title"><i>*</i>{{$t('credentials_法人/负责人名称')}}</span><a-input :placeholder="$t('credentials_请与证件名称保持一致')" class="login-input" style="" v-model="corporateChecking" /></div>
        <div class="credentials-align">
            <span class="item-title"><i>*</i>{{$t('credentials_法人/负责人证件类型')}}</span>
            <a-select :value="idCard" style="width: 210px" @change="CardChange">
              <a-select-option value="身份证">
                {{$t('credentials_身份证')}}
              </a-select-option>
              <a-select-option value="护照">
                {{$t('credentials_护照')}}
              </a-select-option>
            </a-select>
        </div>
        <div class="credentials-align"><span class="item-title"><i>*</i>{{$t('credentials_法人/负责人证件号码')}}</span><a-input :placeholder="$t('credentials_请填写法人/负责人证件号码')" class="login-input" style="" v-model="corporateCheckingNumber" /></div>
        <div class="credentials-align" style="align-items: flex-start;">
          <span class="item-title"><i>*</i>{{$t('credentials_法人/负责人证件附件')}}</span>
          <div class="up-domian">
            <div style="display:flex;">
              <span class="upload-example">
                <img src="@/assets/z1.png" v-if="!frontImgUrl" alt="" />
                <img class="idcard-avatar" v-if="frontImgUrl" style="width: 100%;height: 100%;" :src="frontImgUrl" alt="avatar" />
              </span>
              <div class="clearfix">
                <a-upload
                  name="avatar"
                  list-type="picture-card"
                  accept="image/jpeg,image/jpg,image/png,image/jpg,image/bmp"
                  class="avatar-uploader"
                  :show-upload-list="false"
                  :before-upload="frontChange"
                >
                  <div class="color-upoload">
                    <a-icon :type="loading ? 'loading' : 'plus'" />
                    <div class="ant-upload-text">
                      {{$t('common_upload')}}
                    </div>
                  </div>
                </a-upload>
              </div>
            </div>
            <div style="display:flex;margin-top: 10px;">
              <span class="upload-example">
                <img v-if="!behindImgUrl" src="@/assets/z2.png" alt="" />
                <img class="idcard-avatar" v-if="behindImgUrl" :src="behindImgUrl" style="width: 100%;height: 100%;" alt="avatar" />
              </span>
              <div class="clearfix">
                <a-upload
                  name="avatar"
                  list-type="picture-card"
                  class="avatar-uploader"
                  accept="image/jpeg,image/jpg,image/png,image/jpg,image/bmp"
                  :show-upload-list="false"
                  :before-upload="behindChange"
                >
                  <div class="color-upoload">
                    <a-icon :type="behindLoading ? 'loading' : 'plus'" />
                    <div class="ant-upload-text">
                      {{$t('common_upload')}}
                    </div>
                  </div>
                </a-upload>
              </div>
            </div>
            <div class="up-tips"><i>*</i>{{$t('credentials_请上传本人手持身份证正反面照片；支持.jpg .jpeg .bmp .png格式照片，大小不超过2M')}}</div>
          </div>
        </div>
        <div class="credentials-align">
          <span class="item-title"><i>*</i>{{$t('credentials_法人/负责人证件地址')}}</span>
          <V-distpicker :regiono="legalPersonAdres" @setAddress="legalPersonAddress" />
          <a-input :placeholder="$t('credentials_请填写详细地址')" class="login-input" style="width:274px;height:30px;margin-left:0;" v-model="legalPersonAddressDetail" />
        </div>
    </div>
      <div class="bottomBox">
        <a-button @click="backToTab" type="" style="min-width: 60px;margin-right: 12px;">
          {{$t('credentials_返回')}}
        </a-button>
        <a-button @click="submit" type="primary">
          {{$t('credentials_提交审核')}}
        </a-button>
      </div>
  </div>
</template>

<script>
import moment from 'moment'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import { openNotificationWithIcon, encrypt, decrypt } from '@/utils/util'
import { SsoSetSubject } from '@/api/login'
import { mapGetters } from 'vuex'
import VDistpicker from '@/components/VDistpicker.vue'
import api from '@/api/index'

export default {
  components: {
    VDistpicker
  },
  data () {
    return {
      loading: false,
      previewVisible: false,
      previewImage: '',
      fileList: [],
      idCertificate: '营业执照',
      idCard: '身份证',
      staff: null,
      isForever: false,
      capital: '',
      idNumber: '',
      businessName: '',
      lifeSpan: null,
      companyLoading: false,
      behindLoading: false,
      companyAddressDetail: '',
      frontImgUrl: '',
      behindImgUrl: '',
      temp: {
        address__province: '',
        address__city: '',
        address__dist: ''
      },
      legalPersonAddressDetail: '',
      corporateCheckingNumber: '',
      corporateChecking: '',
      companyAdres: {
        provinName: '',
        cityName: '',
        areaName: '',
        provinCode: '',
        cityedCode: '',
        areaCode: ''
      },
      legalPersonAdres: {
        provinName: '',
        cityName: '',
        areaName: '',
        provinCode: '',
        cityedCode: '',
        areaCode: ''
      },
      picList: []
    }
  },
  computed: {
    ...mapGetters(['personalData'])
  },
  methods: {
    moment,
    backToTab () {
      this.$emit('backToTab')
    },
    idHandleChange (value) {
      this.idCertificate = value
    },
    handleInput (e) {
      this.handleLimitNum(e.target.value)
    },
    handleLimitNum (value) {
      const nameReg = /^\s+|\s+$/
      if (nameReg.test(value)) {
        return openNotificationWithIcon(this.$t('credentials_企业名称前后不能包含空格'))
      }
    },
    // 员工规模
    staffHandleChange (value) {
      this.staff = value
    },
    dateOnChange (date, dateString) {
      this.lifeSpan = dateString
    },
    disabledDate (current) {
      let dateTime = new Date()
      dateTime = dateTime.setDate(dateTime.getDate() - 1)
      dateTime = moment(dateTime).endOf('day')
      return current && current < dateTime
    },
    onChange1 (e) {
      this.isForever = e.target.checked
    },
    beforeUploads (file) {
      if (file.size / 1024 / 1024 > 2) {
        this.$message.error('文件大于2MB哦!')
        return false
      }
      const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/bmp' || file.type === 'image/jpg'
      if (!isJpgOrPng) {
        this.$message.error('请上传JPG、png、bmp、jpg文件!')
        return false
      }
      this.companyLoading = true
      var vFD = new FormData()
      vFD.append('file', file)
      vFD.append('side', 'front')
      vFD.append('source', 'verify')
      vFD.append('token', this.$ls.get(ACCESS_TOKEN))
      this.saveFile(vFD, (data) => {
        file.url = JSON.parse(data.currentTarget.response).data
        this.fileList = [...this.fileList, file]
        this.picList.push({ uid: this.fileList[this.fileList.length - 1].uid, pic: JSON.parse(data.currentTarget.response).data, status: 'done', name: 'image.jpg' })
        this.companyLoading = false
      })
      return false
    },
    // 删除
    handremove (file) {
      const index = this.fileList.indexOf(file)
      const newFileList = this.fileList.slice()
      newFileList.splice(index, 1)
      this.fileList = newFileList
      this.picList = this.picList.splice(index, 1)
      this.picList = this.fileList
    },
    saveFile (vFD, callBack) {
      var xhr = new XMLHttpRequest()
      xhr.open(
        'post',
        `${api.UpLoadImg}`
      )
      xhr.send(vFD)
      xhr.addEventListener('readystatechange', function (data) { // 原生返回
        if (xhr.readyState === 4) {
          if (xhr.status === 200) {
            if (JSON.parse(data.currentTarget.response).code === '200') {
              return callBack(data)
            } else {
              openNotificationWithIcon(JSON.parse(data.currentTarget.response).message)
            }
          }
        }
      })
    },
    handleCancel () {
      this.previewVisible = false
    },
    companyAddress (info) {
      this.companyAdres = {
        provinName: info.provinName,
        cityName: info.cityName,
        areaName: info.areaName,
        provinCode: info.provinCode,
        cityedCode: info.cityedCode,
        areaCode: info.areaCode
      }
      // console.log(info)
    },
    legalPersonAddress (info) {
      this.legalPersonAdres = {
        provinName: info.provinName,
        cityName: info.cityName,
        areaName: info.areaName,
        provinCode: info.provinCode,
        cityedCode: info.cityedCode,
        areaCode: info.areaCode
      }
    },
    // 个人证件选择
    CardChange (value) {
      this.idCard = value
    },
    // 前置页面
    frontChange (file) {
      if (file.size / 1024 / 1024 > 2) {
        this.$message.error(this.$t('Files larger than 2 MB') + '!')
        return false
      }
      const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/bmp' || file.type === 'image/jpg'
      if (!isJpgOrPng) {
        this.$message.error(this.$t('credentials_请上传JPG、png、bmp、jpg文件') + '!')
        return false
      }
      this.loading = true
      var vFD = new FormData()
      vFD.append('file', file)
      vFD.append('source', 'verify')
      vFD.append('token', this.$ls.get(ACCESS_TOKEN))
      this.saveFile(vFD, (data) => {
        this.frontImgUrl = JSON.parse(data.currentTarget.response).data
        this.loading = false
      })
      return false
    },
    // 后置页面
    behindChange (file) {
      if (file.size / 1024 / 1024 > 2) {
        this.$message.error('文件大于2MB哦!')
        return false
      }
      const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/bmp' || file.type === 'image/jpg'
      if (!isJpgOrPng) {
        this.$message.error('请上传JPG、png、bmp、jpg文件!')
        return false
      }
      this.behindLoading = true
      var vFD = new FormData()
      vFD.append('file', file)
      vFD.append('side', 'front')
      vFD.append('source', 'verify')
      vFD.append('token', this.$ls.get(ACCESS_TOKEN))
      this.saveFile(vFD, (data) => {
        this.behindImgUrl = JSON.parse(data.currentTarget.response).data
        this.behindLoading = false
      })
      return false
    },
    submit () {
      if (this.loading || this.behindLoading || this.companyLoading) return openNotificationWithIcon(this.$t('credentials_请等待图片上传完毕') + '!')
      if (!this.capital) return openNotificationWithIcon(this.$t('credentials_请输入注册资本'))
      if (!this.idNumber) return openNotificationWithIcon(this.$t('credentials_请输入证件号码'))
      if (!this.businessName) return openNotificationWithIcon(this.$t('credentials_请输入企业全称'))
      const nameReg = /^\s+|\s+$/
      if (nameReg.test(this.businessName)) return openNotificationWithIcon(this.$t('credentials_企业名称前后不能包含空格'))
      if (!this.staff) return openNotificationWithIcon(this.$t('credentials_请选择员工规模'))
      if (this.isForever) { // 永续
        this.lifeSpan = null
      } else {
        if (!this.lifeSpan) return openNotificationWithIcon(this.$t('credentials_请输入有效期'))
      }
      if (this.fileList.length === 0) return openNotificationWithIcon(this.$t('credentials_请上传企业证件附件'))
      if (!this.corporateChecking) return openNotificationWithIcon(this.$t('credentials_请上传法人/负责人名称'))
      if (!this.corporateCheckingNumber) return openNotificationWithIcon(this.$t('credentials_请上传法人/负责人证件号码'))
      if (!this.frontImgUrl) return openNotificationWithIcon(this.$t('credentials_请上传法人/负责人证件附件'))
      if (!this.behindImgUrl) return openNotificationWithIcon(this.$t('credentials_请上传法人/负责人证件附件'))
      if (!this.companyAddressDetail) return openNotificationWithIcon(this.$t('credentials_请填写企业证件详细地址'))
      if (!this.legalPersonAddressDetail) return openNotificationWithIcon(this.$t('credentials_请填写法人/负责人证件详细地址'))
      if (!this.companyAdres.provinName) return openNotificationWithIcon(this.$t('credentials_请选择企业证件地址省份'))
      if (!this.companyAdres.cityName) return openNotificationWithIcon(this.$t('credentials_请选择企业证件地址城市'))
      if (!this.companyAdres.areaName) return openNotificationWithIcon(this.$t('credentials_请选择企业证件地址区域'))
      if (!this.legalPersonAdres.provinName) return openNotificationWithIcon(this.$t('credentials_请选择法人/负责人证件地址省份'))
      if (!this.legalPersonAdres.cityName) return openNotificationWithIcon(this.$t('credentials_请选择法人/负责人证件地址城市'))
      if (!this.legalPersonAdres.areaName) return openNotificationWithIcon(this.$t('credentials_请选择法人/负责人证件地址区域'))
      let arrPic = '' // eslint-disable-line no-unused-vars
      let arrStr = []
      this.picList.map((item) => {
        if (item.url) {
          arrStr.push(item.url)
        } else {
          arrStr.push(item.pic)
        }
      })
      arrPic = arrStr.join()
      let data = {
        certificateAddress: this.companyAddressDetail, // 企业证件地址详细地址
        certificateArea: Number(this.companyAdres.areaCode), // 企业证件地址区域
        certificateCity: Number(this.companyAdres.cityedCode), // 企业证件地址城市
        certificateProvince: Number(this.companyAdres.provinCode), // 企业证件地址省
        certificateNo: encrypt(this.idNumber || ''), // 企业证件号码
        certificateType: this.idCertificate === '营业执照' ? '1' : '0', // 企业证件类型 0 税务登记证 1是营业执照
        certificateUrl: arrPic, // 企业证件附件地址[]
        certificateValidity: this.lifeSpan, // 企业证件有效期时间
        certificatePermanent: this.isForever ? 1 : 0,
        companyName: this.businessName, // 公司名称
        companySize: this.staff, // 企业规模
        leadAddress: this.legalPersonAddressDetail, // 企业法人/个人证件详细地址
        leadCertificateNo: encrypt(this.corporateCheckingNumber || ''), // 企业法人/个人证件号码
        leadCertificateType: this.idCard === '身份证' ? '0' : '1', // 企业法人/个人证件类型
        leadArea: Number(this.legalPersonAdres.areaCode), // 企业法人/个人证件区域
        leadCity: Number(this.legalPersonAdres.cityedCode), // 企业法人/个人证件城市
        leadProvince: Number(this.legalPersonAdres.provinCode), // 企业法人/个人证件省份
        leadName: this.corporateChecking, // 负责人姓名/个人姓名
        leadCertificateUrl: this.frontImgUrl + ',' + this.behindImgUrl, // 企业法人/个人证件附件地址
        optUserId: '', //
        realName: '', // 真实姓名
        registeredCapital: this.capital, // 注册资本
        systemCode: '', // 系统
        userId: '',
        authenticationType: 2,
        extId: this.personalData?.subjectStatus === 1 ? null : this.personalData?.extId
      }
      SsoSetSubject(data).then((res) => {
        if (res.code === '200') {
          this.$emit('submit')
        } else {
          openNotificationWithIcon(res.message)
        }
      })
    }
  },
  mounted () {
    this.companyAdres.areaCode = ''
    this.companyAddressDetail = this.personalData?.certificateAddress || undefined // 企业证件地址详细地址
    this.companyAdres.areaCode = this.personalData?.certificateArea || undefined // 企业证件地址区域
    this.companyAdres.cityedCode = this.personalData?.certificateCity || undefined // 企业证件地址城市
    this.companyAdres.provinCode = this.personalData?.certificateProvince || undefined // 企业证件地址省
    this.idNumber = decrypt(this.personalData?.certificateNo || '') // 企业证件号码
    this.idCertificate = this.personalData?.certificateType === '1' ? '营业执照' : '税务登记证'
    this.fileList = []
    this.picList = []
    if (this.personalData?.certificateUrl) { // 企业证件附件地址[]---？
      let picArr = []
      picArr = this.personalData?.certificateUrl.split(',') || []

      picArr.map((item, index) => {
        if (index <= 3) {
          this.fileList.push({ uid: 'vc-upload-1589793667395-' + index + 10, name: 'image.jpg', status: 'done', url: item, size: 10000 })
          this.picList.push({ uid: 'vc-upload-1589793667395-' + index + 10, pic: item })
        }
      })
    }
    this.frontImgUrl = ''
    this.behindImgUrl = ''
    if (this.personalData?.leadCertificateUrl) { // 企业法人/个人证件附件地址
      let frontArr = []
      frontArr = this.personalData?.leadCertificateUrl.split(',') || []
      this.frontImgUrl = frontArr[0] || ''
      this.behindImgUrl = frontArr[1] || ''
    }
    this.lifeSpan = this.personalData?.certificateValidity // 转化时间格式
    if (this.personalData?.certificatePermanent === 1) { // 永续
      this.isForever = true
    } else {
      this.isForever = false
    }
    this.businessName = this.personalData?.companyNamePending || this.personalData?.companyName // 公司名称
    this.staff = this.personalData?.companySize || undefined // 企业规模
    this.corporateCheckingNumber = decrypt(this.personalData?.leadCertificateNo || '') // 企业法人/个人证件号码
    this.idCard = this.personalData?.leadCertificateType === '0' ? '身份证' : this.personalData?.leadCertificateType === '1' ? '护照' : '身份证' // 企业法人/个人证件类型
    this.corporateChecking = this.personalData?.leadName // 负责人姓名/个人姓名
    this.legalPersonAdres.areaCode = ''
    this.legalPersonAdres.provinCode = this.personalData?.leadProvince // 企业法人/个人证件省份
    this.legalPersonAdres.cityedCode = this.personalData?.leadCity // 企业法人/个人证件城市
    this.legalPersonAdres.areaCode = this.personalData?.leadArea // 企业法人/个人证件城市
    this.legalPersonAddressDetail = this.personalData?.leadAddress // 企业法人/个人证件详细地址
    this.capital = this.personalData?.registeredCapital // 注册资本
  }
}
</script>

<style lang="less" scoped>
.baseBox {
  // position: relative;
  height: calc(100vh - 209px);
  overflow-y: auto;
}
.contentBox {
  padding-bottom: 55px;
  // padding-left: 12px;
  // max-height: 80%;
  // overflow-y: auto;
}
.credentials {
  text-align: left;
  background-color: #fff;
  padding-top: 25px;
  padding-left: 24px;
  font-family:PingFangSC-Regular,PingFang SC;
  .title {
    display: flex;
    align-items: center;
    font-size:14px;
    font-weight: bold;
    color: rgba(0, 0, 0, 0.85);
    padding-left: 8px;
    font-family: MicrosoftYaHei;
    margin-bottom: 16px;
    border-left: 3px solid #077BFC;
    height: 14px;
  }
  .item-title {
    min-width: 130px;
    text-align: right;
    font-size: 12px;
    // margin-left: 17px;
    margin-right: 12px;
    display: inline-block;
    i {
      color: #E02020;
    }
    .item-opt {
      font-size: 14px;
      margin-left: 20px;
    }
  }
  .content {
    width:1107px;
    margin:0 auto;
    margin-top:28px;
    line-height:36px;
    font-size:18px;
    padding-bottom: 47px;
    margin-bottom: 47px;
  }
}
.credentials-align {
  display:flex;
  align-items: center;
  margin-bottom: 18px;
}
.upload-example {
  display: inline-block;
  width: 146px;
  height: 102px;
  border: 1px dashed #DDDDDD;
  text-align: center;
  margin-right: 12px;
  line-height: 110px;
  img {
    width: 71px;
    height: 73px;
    margin-top: -10px;
  }
}
.up-tips {
  font-weight:400;
  color:#555555;
  font-size:12px;
  // margin-top: 15px;
  margin-bottom: 16px;
  i {
    color: #E02020;
  }
}
.credentials /deep/ .ant-upload.ant-upload-select-picture-card {
  width: 110px!important;
  height: 110px!important;
  margin: 0;
  margin-left: 10px;
}
.idcard-avatar {
  width: 93px;
  height: 93px;
}
.color-upoload {
  color: #4978D6;
}
.login-input {
  display: inline-block;
  width: 210px;
  height: 30px;
  border-radius: 2px;
  border: 1px solid #D9D9D9;
}
.bottomBox {
  position: absolute;
  left: -12px;
  right: -12px;
  height: 56px;
  bottom: 0;
  box-shadow: 0px -2px 2px 0px rgba(152, 161, 171, 0.17);
  display: flex;
  justify-content: center;
  align-items: center;
  background: #fff;
}
.distpicker-address-wrapper /deep/ select {
  width: 140px;
  margin-right: 18px;
  height: 30px!important;
}
/deep/ .ant-btn {
  border-radius: 2px;
}
.up-domian /deep/ .ant-upload-list-picture-card .ant-upload-list-item {
  width: 102px;
  height: 102px;
  margin: 0 12px 8px 0;
}
/deep/ .ant-select {
  font-size: 12px;
}
/deep/ .ant-input {
  font-size: 12px;
}
</style>
